prevAttributes